import IndexVM from './index-vm';
export default {
  init: function() {
    console.log('Kadenze.StyleGuide initialization function called');

    var data = JSON.parse($('#file_json').val());
    ko.applyBindings(new IndexVM(data), document.getElementById('style-guide'));
  }
};

